import { ImportActions, ImportGetters, ImportMutations, ImportState } from "@medapro-types/Imports/store/imports";
import { createNamespacedHelpers } from "vuex-composition-helpers";

const { useState, useActions, useGetters, useMutations } = createNamespacedHelpers<ImportState, ImportGetters, ImportActions, ImportMutations>("imports");

export const useImportState = () => {
  const state = useState([
    "runningPromises",
    "isSaving",
    "saveMessageSeen",
    "initialDataHash",
    "selectedImport",
    "errors",
    "importProjects",
    "importId",
    "type",
    "sourceStructure",
    "isUploadedNewSourceFile",
    "csvConnectionModel",
    "targetStructure",
    "translationNodeIds",
    "mappings",
    "mappingIdsToDelete",
    "showManageImports",
    "rules",
    "canDeleteExistingStructure",
    "showProgress",
    "abortController",
    "isStoreLoading",
    "externalSourceConnections"
  ]);

  return state;
};
export const useImportGetters = () => {
  const getters = useGetters([
    "hasUnsavedData",
    "isBusy",
    "lastRunSuccess",
    "isSaving",
    "sectionHasError",
    "sectionHasValidationError",
    "hasValidationError",
    "importLanguages"
  ]);
  return getters;
};
export const useImportMutations = () => {
  const mutations = useMutations([
    "set-initial-hash",
    "update-notification-status",
    "add-running-promise",
    "reset-running-promises",
    "set-import-projects",
    "set-selected-import",
    "set-source-structure",
    "set-target-structure",
    "set-translation-node-ids",
    "set-validation-error",
    "set-mappings",
    "set-mapping-ids-to-delete",
    "set-error",
    "set-is-saving",
    "reset-errors",
    "set-is-uploaded-new-source-file",
    "set-csv-connection-model",
    "set-option-can-delete-existing-structure",
    "set-show-manage-imports",
    "set-show-progress",
    "set-abort-controller",
    "set-options",
    "set-source-upload-id"
  ]);

  return mutations;
};
export const useImportActions = () => {
  const actions = useActions([
    "setType",
    "resetRunningPromisesIfResolved",
    "loadImportProjects",
    "loadImportSourceStructure",
    "loadImportTargetStructure",
    "collectTranslationNodeIds",
    "loadImportMappings",
    "setSelectedImport",
    "saveImport",
    "setError",
    "setValidationErrorsIfAny",
    "setImportName",
    "deleteImport",
    "setImportId",
    "uploadSourceFile",
    "setSourceStructureForExternalSource",
    "saveImportSetings",
    "initializeSelectedImport",
    "deleteSourceFile",
    "reloadSourceFile",
    "loadRules",
    "setProgressInfo",
    "cancelActionsIfAny"
  ]);

  return actions;
};
